export const moveArrayElement = <T = unknown>(array: Array<T>, fromIndex: number, toIndex: number): Array<T> => {
  const element = array[fromIndex]!
  const splicedArray = array.toSpliced(fromIndex, 1)
  return splicedArray.toSpliced(toIndex, 0, element)
}

export const moveArrayElementByMovement = <T = unknown>(array: Array<T>, fromIndex: number, movement: MovementType): Array<T> => {
  let toIndex: number
  if (movement === MovementType.MOVE_UP) {
    toIndex = fromIndex - 1
  } else if (movement === MovementType.MOVE_DOWN) {
    toIndex = fromIndex + 1
  } else if (movement === MovementType.MOVE_TO_START) {
    toIndex = 0
  } else if (movement === MovementType.MOVE_TO_END) {
    toIndex = array.length - 1
  } else {
    throw new Error("Invalid movement type")
  }

  return moveArrayElement(array, fromIndex, toIndex)
}
